import { createFileRoute } from "@tanstack/react-router";
import { UsersPage } from "@/features/admin/users-page";
import { ensureUserManagementAccess } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/uzytkownicy")({
	beforeLoad: async () => {
		await ensureUserManagementAccess();
	},
	component: UsersPage,
});
